import { render } from "./AdvisorManage.vue?vue&type=template&id=73dc4957"
import script from "./AdvisorManage.vue?vue&type=script&lang=js"
export * from "./AdvisorManage.vue?vue&type=script&lang=js"

import "./AdvisorManage.vue?vue&type=style&index=0&id=73dc4957&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__